import "./Steps.css"

import Documents from "./Documents"
import Fees from "./Fees"
import { useEffect } from "react"

const Steps = props => {
  useEffect(()=>{
    console.log("time ", props.disablePayableFees)
  },[])
  return (
    <div className="data-center-page">
      <div className="row">
        <div className="col-md-3">
          <div className="ie-center">
            <div className="text-center">
              <div className="d-inline-block ">
                <div className="circle-number ie-center">
                  <span>.</span>
                </div>
              </div>
              <div className="span-x-title">
                Required documents for your application
              </div>
              <Documents type={props.type} />
            </div>
          </div>
        </div>
        {!props.disablePayableFee ? (
          <div className="col-md-3">
            <div className="ie-center">
              <div style={{ textAlign: "center" }}>
                <div style={{ display: "inline-block" }}>
                  <div className="circle-number ie-center">
                    <span>.</span>
                  </div>
                </div>
                <div className="span-x-title"> Payable fee for the license</div>
                <Fees type="plastics" />
              </div>
            </div>
          </div>
        ) : null}

        {!props.disableLicenseValidity ? (
          <div className="col-md-3">
            <div className="ie-center">
              <div style={{ textAlign: "center" }}>
                <div style={{ display: "inline-block" }}>
                  <div className="circle-number ie-center">
                    <span>.</span>
                  </div>
                </div>

                <div className="span-x-title">License Validity</div>
                <div>
                  <div className="simple-card-first">
                    <div className="simple-big-title">
                      <span>{props.licenseValidity}</span>
                    </div>
                    <div className="simple-small-title">
                      <span>Year</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : null}

        {!props.disableProcessingTime ? (
          <div className="col-md-3">
            <div className="ie-center">
              <div style={{ textAlign: "center" }}>
                <div style={{ display: "inline-block" }}>
                  <div className="circle-number ie-center">
                    <span>.</span>
                  </div>
                </div>
                <div className="span-x-title">Processing time</div>
                <div>
                  <div className="simple-card">
                    <div className="simple-big-title">
                      <span>{props.processingTime}</span>
                    </div>
                    <div
                      className="simple-small-title"
                      style={{ marginTop: 10 }}
                    >
                      <span>Within {props.processingTime} days</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : null}
      </div>

      <div className="row">
        <div className="col"></div>
      </div>

      <div className="row">
        <div className="col-12"></div>
      </div>

      <div className="tend-to-bottom"></div>
    </div>
  )
}

export default Steps
